import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
class stockLocation {
  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}get-stock-location`,
    ).catch((e) => {
      throw e.message;
    });
    return response.data.stockLocation;
  };
}
export default new stockLocation();